












import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class CSampler extends Vue {
  sampler = {key: 0, title: "#000000FF", description: "#000000FF", background1: "#FFFFFFFF", background2: "#AAAAAAFF"};

  changeSampler() {
    this.$emit("change-csampler", this.sampler);
  }
}
